import styled from "@emotion/styled";

export const Content = styled.span`
  text-transform: capitalize;
`;
